module.exports = __webpack_public_path__ + "static/media/Ti-Chang.7a0954ab.jpg";